module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange-89a518b2fe4e96d13b785deb1a1ed554.png";